import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  schedule() {
    this.timeout = setTimeout(() => this.poll(), this.intervalValue)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      const payload = await response.json()
      if (payload.ready) {
        window.Turbo.visit(window.location.href, { action: "replace" })
        return
      }
    } catch (_error) {
    }

    this.schedule()
  }
}
